<template>
  <div v-if="!inputGroup">
    <div class="input-line">
      <input
        v-if="type!=='password'"
        ref="input"
        :type="type"
        :placeholder="placeholder"
        v-on:keyup="keyup"
        required
        :class="type"
        :name="name"
        :checked="checked"
        v-on:input="$emit('input', $event.target.value,$event.target)"
        @keyup.enter="$emit('enter',$event.target)"
        :value="value"
        :disabled="disabled"
      />
      <input
        v-else
        ref="input"
        :type="type"
        :placeholder="placeholder"
        @keyup.enter="$emit('enter',$event.target)"
        v-on:keyup="keyup"
        required
        :class="type"
        :name="name"
        :checked="checked"
        v-on:input="$emit('input', $event.target.value,$event.target)"
      />
      <span v-if="type==='checkbox'" class="checkbox-follower"></span>
      <slot name="labelforcheckbox"></slot>
      <div class="sub-holder" v-if="subholder">{{subholder}}</div>
      <div class="password-strong" v-if="type === 'password'&&strange_line">
        <div class="strong-line">
          <div class="line"></div>
          <div class="colored-line" :style="{width:colorLineWidth+'%',background:colorLineColor }"></div>
        </div>
        <div class="strong-title" ref="strongTitle" :style="{color:colorLineColor }">{{strongtitle}}</div>
      </div>
      <svg
        v-on:click="changeType('text');"
        v-if="type === 'password' && strange_line"
        class="password-eye"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="icon/action/visibility_24px">
          <path
            id="icon/action/visibility_24px_2"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15C10.34 15 9 13.66 9 12Z"
            fill="#BBBBBB"
          />
        </g>
      </svg>
      <svg
        v-on:click="changeType();"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        v-if="type === 'password' && strange_line"
        class="password-eye eye-visible"
      >
        <g id="icon/action/visibility_off_24px">
          <path
            id="icon/action/visibility_off_24px_2"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.71 4.5399C2.32 4.1499 2.32 3.5199 2.71 3.1299C3.1 2.7399 3.74 2.7399 4.13 3.1299L20.44 19.4599C20.83 19.8499 20.83 20.4799 20.44 20.8699C20.05 21.2599 19.42 21.2599 19.03 20.8699L16.31 18.1499C14.97 18.6699 13.52 18.9699 12 18.9699C7 18.9699 2.73 15.8599 1 11.4699C1.77 9.4999 3.06 7.7999 4.68 6.5099L2.71 4.5399ZM17 11.4699C17 8.7099 14.76 6.4699 12 6.4699C11.49 6.4699 11 6.5699 10.53 6.7099L8.36 4.5399C9.51 4.1699 10.73 3.9699 12 3.9699C17 3.9699 21.27 7.0799 23 11.4599C22.31 13.2199 21.21 14.7599 19.82 15.9899L16.76 12.9299C16.9 12.4699 17 11.9799 17 11.4699ZM12 16.4699C9.24 16.4699 7 14.2299 7 11.4699C7 10.6999 7.18 9.9699 7.49 9.3299L9.06 10.8999C9.03 11.0799 9 11.2699 9 11.4699C9 13.1299 10.34 14.4699 12 14.4699C12.2 14.4699 12.38 14.4399 12.57 14.3999L14.14 15.9699C13.49 16.2899 12.77 16.4699 12 16.4699ZM14.97 11.1399C14.82 9.7399 13.72 8.6499 12.33 8.4999L14.97 11.1399Z"
            fill="#BBBBBB"
          />
        </g>
      </svg>
    </div>
  </div>
  <div v-else-if="inputGroup">
    <div class="input-line group-input code-group" :style="code_inputs_length">
      <input
        v-for="n in inputGroup"
        :key="n"
        ref="input"
        :type="type"
        :placeholder="placeholder"
        v-on:keyup="keyup"
        @keyup.enter="$emit('enter',$event.target)"
        required
        :name="name+'_'+n"
        :checked="checked"
        v-on:input="$emit('input', $event.target.value,$event.target)"
      />
    </div>
  </div>
</template>

<script>
let colors = {
  red: "#EB4B4B",
  yellow: "#F2C923",
  green: "#22CC61"
};

export default {
  name: "Input",
  data() {
    return {
      colorLineWidth: 0,
      colorLineColor: colors.red,
      strongtitle: "Слабый пароль"
    };
  },
  props: {
    strange_line: {
      default: false
    },
    disabled: {
      default: false
    },
    inputGroup: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: ""
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: "text"
    },
    subholder: {
      type: String,
      default: ""
    },
    name: {
      default: "",
      type: String
    },
    value: {
      default: ""
    }
  },
  methods: {
    keyup: function() {
      if (this.type !== "password" || !this.strange_line) return;
      let curr_val = this.$refs.input.value,
        digit = curr_val.search(/\d/gm) > -1 ? 33.33333 : 0,
        updownChar = curr_val.search(/[A-Z|А-Я]/gm) > -1 ? 33.33333 : 0,
        length = curr_val.split("").length >= 1 ? 10 : 0,
        curr_strong = 0,
        _color = colors.red,
        _title = "Слабый пароль";

      length = curr_val.split("").length > 3 ? 20 : length;
      length = curr_val.split("").length > 6 ? 33.33333 : length;

      curr_strong = digit + updownChar + length;
      _color = curr_strong > 33.33333 ? colors.yellow : _color;
      _color = curr_strong > 55 && length === 33.33333 ? colors.green : _color;
      _title = curr_strong > 33.33333 ? "Средненький" : _title;
      _title = curr_strong > 55 && length === 33.33333 ? "Надежный" : _title;

      this.colorLineWidth = curr_strong;
      this.colorLineColor = _color;
      this.strongtitle = _title;

      if (curr_strong > 0) {
        this.$refs.strongTitle.style = "opacity:1;color:" + this.colorLineColor;
      } else {
        this.$refs.strongTitle.style =
          "opacity:0; color:" + this.colorLineColor;
      }
    },
    setAttr: function(name = "", value = "") {
      if (name && value) this.$refs.input.setAttribute(name, value);
    },
    getInput: function() {
      return this.$refs.input;
    },
    changeType: function(type = this.type) {
      this.$refs.input.type = type;
    },
    getValue: function() {
      return this.$refs.input.value;
    }
  },
  computed: {
    code_inputs_length() {
      return "grid-template-columns: repeat(" + this.inputGroup + ", 1fr);";
    }
  },
  mounted: function() {}
};
</script>

<style lang="scss" scoped>
.alarm {
  .sub-holder {
    color: $alarmColor !important;
  }
  input {
    border-color: $alarmColor !important;
  }
}
$padding: 20px;
input,
textarea {
  transition: border-color 0.2s;
  @include border($calmColor);
  &:focus {
    border-color: $mainColor;
  }
}

.input-line {
  position: relative;
  .sub-holder {
    opacity: 0;
    transition: all 0.2s;
    position: absolute;
    top: -10px;
    left: 8px;
    color: $calmColor;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    padding-left: 9px;
    padding-right: 9px;
    background: #fff;
  }
  input {
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
    padding: 15px $padding;

    &.password {
      padding-right: 50px;
    }

    &::placeholder {
      color: #8e8e8e;
    }
    &:focus,
    &:valid,
    &:not(:placeholder-shown) {
      & ~ .password-strong {
        opacity: 1;
      }
    }

    &:not(:placeholder-shown) {
      & + .sub-holder {
        opacity: 1;
      }
      &:focus {
        & + .sub-holder {
          color: $mainColor;
        }
      }
    }
    &[type="password"] {
      & ~ .eye-visible {
        display: none;
      }
      &:not(:placeholder-shown) {
        font-size: 20px;
        line-height: 1;
        letter-spacing: 12px;
      }
    }
    &[type="text"] {
      & ~ .password-eye {
        display: none;
      }
      & ~ .eye-visible {
        display: block;
      }
    }
  }
  .password-eye {
    position: absolute;
    top: calc(50% - 12px);
    right: $padding;
    cursor: pointer;
  }
  .password-strong {
    position: absolute;
    opacity: 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    transition: all 0.2s;

    .strong-line {
      position: relative;
      flex: 0 1 60%;
      max-width: 60%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 4px;
      height: 25px;
      @media (max-width: 360px) {
        flex: 0 1 100%;
        max-width: 100%;
      }
      .line,
      .colored-line {
        width: 100%;
        height: 4px;
        border-radius: 4px;
        background-color: #e0e0e0;
        border: 1px solid #e0e0e0;
      }
      .colored-line {
        transition: all 0.2s;
        width: 0%;
        position: absolute;
        background: red;
      }
    }
    .strong-title {
      flex: 1 0 36%;
      max-width: 36%;
      opacity: 0;
      text-align: right;
      @media (max-width: 360px) {
        flex: 0 1 100%;
        max-width: 100%;
      }
    }
  }
  input[type="checkbox"] {
    display: none;

    & ~ .checkbox-follower {
      display: inline-block;
      margin: 4px;
      width: 18px;
      height: 18px;
      border: 2px solid $calmColor;
      border-radius: 2px;
      & ~ .label {
        margin-left: 8px;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
      }
    }
    &:checked {
      & ~ .checkbox-follower {
        background-image: url("../../assets/images/check_box.png");
        // background-image: url("../../assets/icons/check_box.svg");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        border: none;
      }
    }
  }
  &.group-input {
    display: grid;
    grid-column-gap: 24px;
  }
  [disabled="disabled"] {
    opacity: 0.4;
  }
}
input:invalid {
  box-shadow: none;
}
.code-group {
  input {
    padding: 15px;
    text-align: center;
  }
}
</style>